import React from 'react'
import icon from '../assets/img/availability-icon.png'

export const WEEKLY_CUSTOM_THEME = {
  // week header 'dayname'
  'week.dayname.height': '41px',
  'week.dayname.borderTop': '1px solid #ddd',
  'week.dayname.borderBottom': '1px solid #ddd',
  'week.dayname.borderLeft': '1px solid #ddd',
  'week.dayname.paddingLeft': '5px',
  'week.dayname.backgroundColor': 'inherit',
  'week.dayname.textAlign': 'left',
  'week.today.color': '#b857d8',
  'week.pastDay.color': '#999',

  // week vertical panel 'vpanel'
  'week.vpanelSplitter.border': '1px solid #ddd',
  'week.vpanelSplitter.height': '3px',

  // week daygrid 'daygrid'
  'week.daygrid.borderRight': '1px solid #ddd',
  'week.daygrid.backgroundColor': 'inherit',

  'week.daygridLeft.width': '77px',
  'week.daygridLeft.backgroundColor': '#a8def74d',
  'week.daygridLeft.paddingRight': '5px',
  'week.daygridLeft.borderRight': '1px solid #ddd',

  'week.today.backgroundColor': '#b857d81f',
  'week.weekend.backgroundColor': 'inherit',

  // week timegrid 'timegrid'
  'week.timegridLeft.width': '77px',
  'week.timegridLeft.backgroundColor': '#03a9f44d',
  'week.timegridLeft.borderRight': '1px solid #ddd',
  'week.timegridLeft.fontSize': '12px',
  'week.timegridLeftTimezoneLabel.height': '51px',
  'week.timegridLeftAdditionalTimezone.backgroundColor': '#fdfdfd',

  'week.timegridOneHour.height': '48px',
  'week.timegridHalfHour.height': '24px',
  'week.timegridHalfHour.borderBottom': '1px dotted #f9f9f9',
  'week.timegridHorizontalLine.borderBottom': '1px solid #eee',

  'week.timegrid.paddingRight': '10px',
  'week.timegrid.borderRight': '1px solid #ddd',
  'week.timegridSchedule.borderRadius': '0',
  'week.timegridSchedule.paddingLeft': '0',

  'week.currentTime.color': '#135de6',
  'week.currentTime.fontSize': '12px',
  'week.currentTime.fontWeight': 'bold',

  'week.pastTime.color': '#808080',
  'week.pastTime.fontWeight': 'normal',

  'week.futureTime.color': '#333',
  'week.futureTime.fontWeight': 'normal',

  'week.currentTimeLinePast.border': '1px solid rgba(19, 93, 230, 0.3)',
  'week.currentTimeLineBullet.backgroundColor': '#135de6',
  'week.currentTimeLineToday.border': '1px solid #135de6',
  'week.currentTimeLineFuture.border': '1px solid #135de6',

  // week creation guide style
  'week.creationGuide.color': '#135de6',
  'week.creationGuide.fontSize': '12px',
  'week.creationGuide.fontWeight': 'bold',

  // week daygrid schedule style
  'week.dayGridSchedule.borderRadius': '0',
  'week.dayGridSchedule.height': '18px',
  'week.dayGridSchedule.marginTop': '2px',
  'week.dayGridSchedule.marginLeft': '10px',
  'week.dayGridSchedule.marginRight': '10px',
}

export const getGridCategoryTemplate = (category, schedule) => {
  var tpl
  switch (category) {
    case 'allday':
      tpl =
        '<span class="calendar-font-icon ic-milestone-b"></span> <span style="background-color: ' +
        schedule.bgColor +
        '">' +
        schedule.title +
        '</span>'
      break
    case 'task':
      tpl = '#' + schedule.title
      break
  }
  return tpl
}

export const calendarTemplate = {
  monthMoreTitleDate: function (date, dayname) {
    var day = date.split('.')[2]
    return day + '(' + dayname + ')'
  },

  monthMoreClose: function () {
    return '<span class="tui-full-calendar-icon tui-full-calendar-ic-close"></span>'
  },
  schedule: function (schedule) {
    return getGridCategoryTemplate(schedule.category, schedule)
  },

  time: function (schedule) {
    return `<div class="availability-entry">
    <img src="${icon}" class="availability-icon"/>
    ${schedule.title}
    </div>`
  },

  allday: function (schedule) {
    return `<div class="calendar-booking">
    <span class="calendar-booking-desktop">${schedule.title}</span>
    <span class="calendar-booking-mobile">JOB</span>
    </div>`
  },
}

export const buildCalenderControlPanel = (
  onViewChange,
  onHideWeekend,
  handleClickTodayButton,
  handleClickPrevButton,
  handleClickNextButton,
  toggleWeekend,
  today
) => {
  return (
    <div id='menu' className='calendar-menu'>
      <span className='dropdown'>
        <select
          className='btn btn-default btn-sm dropdown-toggle dropwn'
          onChange={onViewChange}
        >
          <option value='month'>Monthly</option>
          <option value='2 weeks'>2 weeks</option>
        </select>
      </span>
      <span id='menu-navi'>
        <button
          type='button'
          className='btn btn-default btn-sm hideWeekend'
          data-action='move-today'
          onClick={onHideWeekend}
        >
          {toggleWeekend}
        </button>
        <button
          type='button'
          className='btn btn-default btn-sm move-today'
          data-action='move-today'
          onClick={handleClickTodayButton}
        >
          Today
        </button>
        <button
          type='button'
          className='btn btn-default btn-sm move-day'
          data-action='move-prev'
          onClick={handleClickPrevButton}
        >
          <i
            className='tui-full-calendar-icon tui-full-calendar-ic-arrow-left'
            data-action='move-prev'
          ></i>
        </button>
        <button
          type='button'
          className='btn btn-default btn-sm move-day'
          data-action='move-next'
          onClick={handleClickNextButton}
        >
          <i
            className='tui-full-calendar-icon tui-full-calendar-ic-arrow-right'
            data-action='move-next'
          ></i>
        </button>
      </span>
      <span id='renderRange' className='render-range mt-3 mt-md-0'>
        {today}
      </span>
    </div>
  )
}

export const buildBookingSchedule = (job) => {
  var bookingsSchedule = []

  if (job.multiple_date) {
    const dates = job.dates
    for (var j = 0; j < dates.length; j++) {
      const date = dates[j]
      const start_time = date.date + 'T' + job.start_time + 'Z'
      const end_time = date.date + 'T' + job.end_time + 'Z'
      const title = job.start_time.slice(0, -3) + ' ' + job.level

      const booking_sche = {
        id: `${job._id}_${j}`,
        calendarId: job._id,
        title: title,
        category: 'allday',
        dueDateClass: '',
        start: start_time,
        end: end_time,
      }

      var duplication = false
      for (var a = 0; a < bookingsSchedule.length; a++) {
        if (job._id === bookingsSchedule[a].id) {
          duplication = true
          break
        }
      }
      if (!duplication) {
        bookingsSchedule.push(booking_sche)
      }
    }
  }

  return bookingsSchedule
}
